import { useEffect } from 'react';

/** Mount-only effect; cleanup runs on unmount. Prefer over raw useEffect([]). */
export function useMountEffect(effect: () => void | (() => void)) {
  // eslint-disable-next-line react-hooks/exhaustive-deps -- intentional mount-only
  useEffect(effect, []);
}
